export default class Request {
    constructor() { }

    public async post(url: string, data: any = {}) {
        const body = new URLSearchParams();
        for (const key of Object.keys(data || {})) {
            const value = data[key];
            if (value === undefined || value === null) continue;
            body.append(key, String(value));
        }

        try {
            const response = await fetch(url, {
                method: "POST",
                body: body,
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
                }
            });
            const text = await response.text();
            if (!text) return {};
            try {
                return JSON.parse(text);
            } catch (e) {
                return text;
            }
        } catch (error: any) {
            return { code: 0, data: { message: error?.message || "request failed" } };
        }
    }

}
